export const P22MackinacMedium = {
  src: `url(https://cdn.ownup.com/component-library/latest/P22MackinacMedium.eot),
        url(https://cdn.ownup.com/component-library/latest/P22MackinacMedium.woff)`
};
